import { Form, FormSelect, FormTextField, getIn } from '../Formik/forms'

import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'

import useClientMetadata from 'hooks/useClientMetadata'
import { PAYOUT_LABEL_MAP } from 'components/AllocationsTable/AllocationsTable'

export default function AddClientCampaignForm({contract, clientCampaign, programGroupsResource, onSave, isNewCampaign, clientId}) {
  const { clientCampaignCustomAttributes } = useClientMetadata([clientId])

  return (
    <Form
      resource={clientCampaign}
      relatedResource={isNewCampaign ? contract : undefined}
      onSave={onSave}
      redirectAfterSave={false}
      promptOnNavigate={false}
      relationshipIds={['programGroupId']}
    >
      <Stack spacing={2} mt={2}>
        <FormSelect name="programGroupId" label="Program Group" disabled={!isNewCampaign}>
          {programGroupsResource.get()?.map(programGroup => (
            <MenuItem value={programGroup.id} key={programGroup.id}>{programGroup.attributes.description}</MenuItem>
          ))}
        </FormSelect>
        <FormSelect name="payout" label="Lead Pricing" disabled={!isNewCampaign}>
          {Object.entries(PAYOUT_LABEL_MAP)
            .filter(([key]) => getIn(clientCampaign, 'attributes.payout') === 'cost_per_enroll' ? true : key !== 'cost_per_enroll')
            .map(([value, text]) => (
              <MenuItem value={value} key={value}>{text}</MenuItem>
            )
          )}
        </FormSelect>
        <FormTextField name="name" label="Name"/>
        {clientCampaignCustomAttributes.map((name, index) => (
          <FormTextField name={`customAttributes[${name}]`} label={name} key={index} />
        ))}
      </Stack>
    </Form>
  )
}
